import { sagaCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actions, actionTypes } from '../actions/interazioni';
import { selectors, DEFAULT_STATE } from '../reducers/interazioni';
import api from '../apis/interazioni';

const sagas = helper.createSagas(
    'interazioni',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE
);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [...defaultSagas];
